import Navbar from 'bee-navbar'

export default Navbar
